
import { useState } from 'react';
import Button from '../base/Button';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="w-full px-6 py-4 flex justify-between items-center bg-black/20 backdrop-blur-sm sticky top-0 z-50">
      <div className="font-['Pacifico'] text-2xl text-white">
        Stratava AI
      </div>
      
      <nav className="hidden md:flex space-x-8">
        <a href="#home" className="text-white/80 hover:text-white transition-colors cursor-pointer">Home</a>
        <a href="#apps" className="text-white/80 hover:text-white transition-colors cursor-pointer">Features</a>
        <a href="#about" className="text-white/80 hover:text-white transition-colors cursor-pointer">About</a>
        <a href="#contact" className="text-white/80 hover:text-white transition-colors cursor-pointer">Contact</a>
      </nav>

      <div className="hidden md:block">
        <div className="bg-purple-600/20 border border-purple-400/30 text-purple-200 px-6 py-2 rounded-full">
          Coming Soon
        </div>
      </div>

      <button 
        className="md:hidden w-6 h-6 flex items-center justify-center cursor-pointer text-white"
        onClick={() => setIsMenuOpen(!isMenuOpen)}
      >
        <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
      </button>

      {isMenuOpen && (
        <div className="absolute top-full left-0 right-0 bg-black/90 backdrop-blur-sm md:hidden">
          <nav className="flex flex-col space-y-4 p-6">
            <a href="#home" className="text-white/80 hover:text-white transition-colors cursor-pointer">Home</a>
            <a href="#apps" className="text-white/80 hover:text-white transition-colors cursor-pointer">Features</a>
            <a href="#about" className="text-white/80 hover:text-white transition-colors cursor-pointer">About</a>
            <a href="#contact" className="text-white/80 hover:text-white transition-colors cursor-pointer">Contact</a>
            <div className="bg-purple-600/20 border border-purple-400/30 text-purple-200 px-6 py-2 rounded-full text-center">
              Coming Soon
            </div>
          </nav>
        </div>
      )}
    </header>
  );
}
